import type { ReactNode } from 'react'

/** The way into the product, on the landing's own language and motion. The decisions: docs/notes/app/auth-screens.md */
export function AuthLayout(props: { children: ReactNode }) {
  return (
    // The near-black on the primary green is the landing's: white on it is about 2:1 and fails WCAG AA.
    <div className="flex min-h-dvh w-full items-center justify-center py-6 [--primary-foreground:oklch(0.205_0_0)]">
      {props.children}
    </div>
  )
}
